import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AlertComponent } from './_components';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { SweetAlert2ModuStickyModulele } from '@sweetalert2/ngx-sweetalert2';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InterceptService } from './_services/intercept.service';
// import { StickyModule } from 'ng2-sticky-kit';
import { TranslateModule } from '@ngx-translate/core';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsComponent } from './terms/terms.component';


@NgModule({
  imports: [
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    // SweetAlert2Module.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    NgbModule,
    TranslateModule.forRoot(),
    // StickyModule,
   ],
  declarations: [AppComponent,
    AlertComponent,
    TermsComponent,
    PrivacyComponent
  ],
  bootstrap: [AppComponent],
  providers: [
  { provide: HTTP_INTERCEPTORS, useClass: InterceptService, multi: true },
  // { provide: APP_BASE_HREF, useValue: '/' }
]
})
export class AppModule { }
